import BrandDiscountMessage from './BrandDiscountMessage';

export default BrandDiscountMessage;
